// extracted by mini-css-extract-plugin
export default {"container":"styles__container___5JV5Y","icon":"styles__icon___cwz4h"};